import { render } from "./consent-view.vue?vue&type=template&id=9e069546"
import script from "./consent-view.vue?vue&type=script&lang=js"
export * from "./consent-view.vue?vue&type=script&lang=js"

import "./consent-view.vue?vue&type=style&index=0&id=9e069546&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__